module.exports = __webpack_public_path__ + "img/refresh.b06ffe85.svg";